// 推广返利：邀请链接 ?aff=CODE → cookie yc_aff（.yeap.cloud 共享，官网同名 cookie），注册时带给后端。
const COOKIE = 'yc_aff';
const valid = (c) => /^[a-z0-9]{4,16}$/.test(c || '');

export const captureAffiliate = () => {
    try {
        const code = (new URLSearchParams(window.location.search).get('aff') || '').toLowerCase();
        if (!valid(code)) return;
        const h = window.location.hostname;
        const domain = h === 'yeap.cloud' || h.endsWith('.yeap.cloud') ? '; Domain=.yeap.cloud' : '';
        document.cookie = `${COOKIE}=${code}${domain}; Path=/; Max-Age=${86400 * 60}; SameSite=Lax`;
    } catch (_) { /* ignore */ }
};

export const affiliateCode = () => {
    try {
        const fromUrl = (new URLSearchParams(window.location.search).get('aff') || '').toLowerCase();
        if (valid(fromUrl)) return fromUrl;
        const m = document.cookie.match(new RegExp(`(?:^|; )${COOKIE}=([^;]*)`));
        const c = m ? decodeURIComponent(m[1]).toLowerCase() : '';
        return valid(c) ? c : undefined;
    } catch (_) {
        return undefined;
    }
};
